import { Effect } from 'effect';

import { addProductsToFavouriteList } from '../../flow/favourites/addProductsToFavouriteList';
import type { AddProductsToFavouriteListInput } from '../../request/backendApi/favourites/addProductsToFavouriteList';
import { RuntimeClientAtom } from '../../runtime/RuntimeClient';

export const addProductsToFavouriteListAtomFn = RuntimeClientAtom.fn(
  Effect.fnUntraced(function* (params: AddProductsToFavouriteListInput) {
    return yield* addProductsToFavouriteList(params);
  })
);
